import { PrimaryButton } from "Element/Button";
import styled, { css } from "styled-components";
import checkIcon from "assets/icons/check.svg";
import { Flex } from "Element/Flex";

export const WienerBoxWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 24px;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
  `}
`;
export const WienerBoxImgWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 182px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 158px;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    height: 168px;
  `}
`;

export const WienerBoxImgWrapperDesktop = styled(WienerBoxImgWrapper)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `}
`;

export const WienerBoxImgWrapperMobile = styled(WienerBoxImgWrapper)`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: flex;
  `}
`;

export const WienerBoxImg = styled.img`
  position: absolute;
  width: 780px;
  max-width: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 688px;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 355px;
  `}
  :nth-child(1) {
    z-index: 0;
  }
  :nth-child(2) {
    z-index: 2;
  }
`;

export const WienerImgWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: -39px;
  width: 675px;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 545px;
    top: -25px;
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 258px;
    top: -25px;
    justify-content: flex-start;
  `}
`;

export const WienerImg = styled.img`
  width: 105px;
  :nth-child(1) {
    margin-left: 0;
  }
  :nth-child(n + 20) {
    display: none;
  }
  margin-left: -70px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 84px;
    margin-left: -54px;

  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 105px;
    margin-left: -70px;
    :nth-child(1) {
      margin-left: -21px;
    }
    :nth-child(n+7) {
      display:none;
    }
  `}
`;

export const MintInfoWrapper = styled.div`
  width: 693px;
  position: absolute;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  top: 62px;
  margin-left: -35px;
  padding: 10px 16px;

  .mint-info {
    img {
      margin-right: 8px;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width:608px;
    padding: 8px;
    top: 52px;
    margin-left: -32px;
    .mint-info{
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;
  }
    }
  `}

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 251px;
    padding: 8px;
    justify-content: center;
    top: 64px;
    left: 55%;
    transform: translateX(-53%);
    .mint-info{
      flex-direction: column;
      align-items: start;
    }
  `}
`;

export const TokenAmountWrapper = styled(Flex)`
  width: 100%;
  max-width: 315px;
  background-color: ${({ theme }) => theme.colors.neutral00};
  border-radius: 40px;
  padding: 8px 24px 8px 8px;
  justify-content: space-between;
  align-items: center;
`;
const Token = styled.h2`
  margin: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  margin-top: 3px;
  ${({ theme }) => theme.fontStyle.primaryBold}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    ${theme.fontStyle.secondaryBold}
  `}
`;
export const StyledTokenAmount = styled(Token)`
  margin-left: 12px;
  color: ${({ theme }) => theme.colors.polygonPurple};
`;

export const TokenExcRate = styled(Token)`
  color: ${({ theme }) => theme.colors.neutral60};
`;

export const StyledCounter = styled.div`
  /* border: 2px solid ${({ theme }) => theme.colors.neutral80}; */
  ${({ theme }) => theme.fontStyle.primary}
  display: flex;
  align-items: center;
  border-radius: 100px;
  justify-content: center;
  width: 80px;
  outline: none;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.neutral00};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 120px;
    background-color: ${theme.colors.neutral20};
  `};
`;

export const CounterButtonWrapper = styled(Flex)<{ name?: string }>`
  /* display: none; */
  justify-content: center;
  align-items: center;

  .btn-sub {
    margin-right: 12px;
  }
  .btn-add {
    margin-left: 12px;
  }
  ${({ theme, name }) => theme.mediaWidth.upToExtraSmall`
      margin-top: 24px;
      margin-bottom: 40px;
      display: ${name === "mobile" && "flex"}
  `}

  ${({ name }) =>
    name === "mobile" &&
    css`
      display: none;
    `};
`;

export const CounterButton = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  svg {
    width: 20px;
    height: 20px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: fit-content;
  `}
`;

export const MintDesc = styled.p`
  ${({ theme }) => theme.fontStyle.primary}
  text-align: center;
  margin: 0;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    justify-content: flex-start;
  `}
`;

export const TermWrapper = styled(Flex)`
  margin-bottom: 24px;
  cursor: pointer;
`;

export const StyledCheckBox = styled.input`
  appearance: none;
  min-width: 24px;
  min-height: 24px;
  border: 2px solid ${({ theme }) => theme.colors.neutral60};
  border-radius: 5px;
  cursor: pointer;
  margin: 0;
  margin-right: 16px;
  &:checked {
    background-image: url(${checkIcon});
    background-color: ${({ theme }) => theme.colors.success};
    border-color: ${({ theme }) => theme.colors.success};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
      width: 20px;
      height: 20px;
  `}
`;

export const StyledTerm = styled.span`
  ${({ theme }) => theme.fontStyle.primary}
  color:  ${({ theme }) => theme.colors.neutral60};
  margin-top: 5px;
  line-height: 88%;
  ${({ theme }) => theme.mediaWidth.upToXxs`
    margin-top:0;
  `}
`;

export const ButtonWrapper = styled(Flex)`
  width: 100%;
  button {
    :first-child {
      margin-right: 36px;
      ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        margin-right: 0;
        margin-bottom: 16px
      `}
    }
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      flex-direction: column;
  `}
`;
